import contractTimeout from './contract-timeout.json';

export default {
  timeout: {
    ...contractTimeout,
  },
};
